export const REFRESH_PAGE_ROUTE = 'refresh';
export const ACCESS_ID_PARAM = 'accessId';
export const DATA_VIEW_QUERY_PARAM = 'query';
export const DATA_VIEW_QUERY_ID_PARAM = 'query_id';
